import { format, parse } from 'date-fns';
import { ptBR } from 'date-fns/locale';

export function formatDate(dateStr: string): string {
  try {
    return format(parse(dateStr, 'yyyy-MM-dd', new Date()), 'MM/yyyy', {
      locale: ptBR,
    });
  } catch {
    return dateStr;
  }
}

export function formatDateShort(dateStr: string): string {
  try {
    return format(parse(dateStr, 'yyyy-MM-dd', new Date()), 'MMM yyyy', {
      locale: ptBR,
    });
  } catch {
    return dateStr;
  }
}
